module.exports = __webpack_public_path__ + "img/fc85c87.png";